import { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api, formatApiErrorDetail } from "../lib/api";
import { disableBrowserPush, enableBrowserPush, pushSupported } from "../lib/push";
import { Button } from "./ui/button";

export const BrowserPushSettings = () => {
  const { user } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const supported = pushSupported();
  useEffect(() => {
    let active = true;
    setEnabled(false);
    if (supported && user?.role === "buyer") navigator.serviceWorker.getRegistration("/").then(async (registration) => {
      const sub = await registration?.pushManager.getSubscription();
      if (sub) { const { data } = await api.post("/push/status", { endpoint: sub.endpoint }); if (active) setEnabled(data.enabled); }
    }).catch(() => { if (active) setError("Could not check notification settings. Please try again."); });
    return () => { active = false; };
  }, [user?.id, user?.role, supported]);
  if (user?.role !== "buyer") return null;
  const toggle = async () => {
    setBusy(true); setError("");
    try { if (enabled) await disableBrowserPush(); else await enableBrowserPush(); setEnabled(!enabled); }
    catch (e) { setError(e.response ? formatApiErrorDetail(e.response.data?.detail) : e.message); }
    finally { setBusy(false); }
  };
  return <section className="mt-4 border border-border bg-white p-4 space-y-2" data-testid="browser-push-settings">
    <h2 className="text-sm font-semibold flex items-center gap-2"><BellRing className="w-4 h-4 text-terracotta" />Browser stock alerts</h2>
    <p className="text-xs text-charcoal-muted">Receive back-in-stock notifications for items you follow, even with TerraZoon tabs closed. Delivery depends on your browser and device settings.</p>
    {supported ? <><p data-testid="browser-push-status" className="text-xs font-medium">{enabled ? "Enabled on this browser" : "Not enabled on this browser"}</p><Button data-testid="browser-push-toggle" disabled={busy} onClick={toggle} variant="outline" size="sm">{busy ? "Updating…" : enabled ? "Turn off browser notifications" : "Enable browser notifications"}</Button></> : <p data-testid="browser-push-unsupported" className="text-xs text-charcoal-muted">Push isn't available here. Try a supported browser; on iPhone/iPad, add TerraZoon to your Home Screen first. Email and in-app alerts remain available.</p>}
    {error && <p role="alert" data-testid="browser-push-error" className="text-xs text-destructive">{error}</p>}
  </section>;
};
